import { useEffect, useState } from 'react';
import { useGetCoCustomerChatsCountQuery } from 'src/services/coCustomerAnalyticsService';
import { DateItems } from 'src/pages/AnalyticsPage/AnalyticsCustomer/DateItems';
import { ANALYTICS_COCUSTOMER_INITIAL_STATE as INITIAL_STATE } from 'src/pages/AnalyticsPage/AnalyticsCustomer/AnalyticsCoCustomerInitialState';
import {
  DateRangeItem,
  MetricValue,
} from 'src/pages/AnalyticsPage/AnalyticsCustomer/AnalyticsCoCustomer.types';

/**
 * Derives the "in-progress tickets" metric: it comes from the open-chats-count query,
 * but only applies to date ranges that support showing in-progress tickets (see DateItems).
 */
export const useInProgressTickets = (projectId: string, dateRange: DateRangeItem) => {
  const { data: openChatsCountData } = useGetCoCustomerChatsCountQuery(
    { project_ids: projectId, statuses: 'open' },
    { skip: !projectId },
  );
  const [inProgressTickets, setInProgressTickets] = useState(INITIAL_STATE.inProgressTickets);

  useEffect(() => {
    const dateItem = DateItems.find((item) => item.label === dateRange.label) as DateRangeItem;
    const tickets: MetricValue = { value: 'N/A', percentage: 0 };

    if (dateItem.showInProgressTickets && openChatsCountData) {
      tickets.value = openChatsCountData.count;
    }

    setInProgressTickets(tickets);
  }, [dateRange, openChatsCountData]);

  return inProgressTickets;
};
